// Copyright (c) 2019 Deere & Company

// changes identifying property for lead accounts and cities so they can be considered unique across all territories

export const seperateLeadAccountsByTerritory = territories => {

    territories.forEach((territory, territoryIndex, territoryArr) => {

        territory.leadAccounts.forEach((leadAccount, leadAccountIndex) => {

            territoryArr[territoryIndex].leadAccounts[leadAccountIndex].id = `${territory.territory}-${leadAccount.id}`;
            territoryArr[territoryIndex].leadAccounts[leadAccountIndex].dealer.account = leadAccount.id;

            leadAccount.cities.forEach((city, cityIndex) => {

                territoryArr[territoryIndex].leadAccounts[leadAccountIndex].cities[cityIndex].id = `${territory.territory}-${city.id}`;

            });

        });

    });

    return territories;

};



// WEBPACK FOOTER //
// ./src/user/shared/services/tcsm-territories-helper.js